import React from "react";

function RequiredAsterisk() {
  return <span className="text-accent-pink">*</span>;
}

export default RequiredAsterisk;
